import { Command, usePrintActionHandler } from '@nest/internal-frontend';
import { PrinterIcon } from 'lucide-react';
import { useTerminalClient } from '../client-rpc-router';

export const useCommandStockItemPrintLabels = ({ id }: { id?: number }): Command => {
	const client = useTerminalClient();
	const printerHandler = usePrintActionHandler(
		'stock-item-labels',
		async (numberOfCopies, printerIds) => {
			await client.wms.printStockItemLabelMutation.execute({ id: id!, numberOfCopies, printerIds });
		},
		{
			numberOfCopies: 1,
			allowedActions: ['print']
		}
	);

	return {
		id: 'print-stock-item-labels',
		label: 'Tisk štítků',
		icon: <PrinterIcon className="h-4 w-4" />,
		shortcut: undefined,
		disabled: !id,
		loading: printerHandler.isLoading,
		run: async () => {
			await printerHandler.run(undefined);
		}
	};
};
